/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  PhoneConnectRequest,
  PhoneConnectResponse
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * The admin-consent URL for the firm's Microsoft tenant. ORG ADMINS ONLY.
 *
 * Built here, not in the browser, so the state is one this server will
 * recognise on the way back. In mock mode the URL is the redirect itself.
 * `tenantHint` is optional (single-tenant apps); see `connect.py`.
 * @summary Begin Phone Connection
 */
export const beginPhoneConnection = (
    phoneConnectRequest: PhoneConnectRequest,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<PhoneConnectResponse>(
      {url: `/phone/connect`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: phoneConnectRequest, signal
    },
      options);
    }




export const getBeginPhoneConnectionMutationKey = () => ['beginPhoneConnection'] as const;

export const getBeginPhoneConnectionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof beginPhoneConnection>>, TError,BeginPhoneConnectionMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof beginPhoneConnection>>, TError,BeginPhoneConnectionMutationVariables, TContext> => {

const mutationKey = getBeginPhoneConnectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof beginPhoneConnection>>, BeginPhoneConnectionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  beginPhoneConnection(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BeginPhoneConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof beginPhoneConnection>>>
    export type BeginPhoneConnectionMutationBody = PhoneConnectRequest
    export type BeginPhoneConnectionMutationError = HTTPValidationError
    export type BeginPhoneConnectionMutationVariables = {data: PhoneConnectRequest}

    /**
 * @summary Begin Phone Connection
 */
export const useBeginPhoneConnection = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof beginPhoneConnection>>, TError,BeginPhoneConnectionMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof beginPhoneConnection>>,
        TError,
        BeginPhoneConnectionMutationVariables,
        TContext
      > => {
      return useMutation(getBeginPhoneConnectionMutationOptions(options));
    }
